export function getCountryByCode(countryCode: string): string | undefined {
  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })
  return regionNames.of(countryCode)
}
